<div
  [class.video-result]="!isDesktop()"
  [class.video-result-desktop]="isDesktop()">
  <div class="thumbnail-wrapper">
    @if (video().youtubeId) {
      <img
        class="thumbnail"
        [src]="
          'https://img.youtube.com/vi/' + video().youtubeId + '/hqdefault.jpg'
        "
        [alt]="video().title" />
    }
    <span class="duration">
      {{ video().duration && formatDuration(video().duration) }}
    </span>
  </div>

  <div class="info">
    <div class="title">{{ video().title }}</div>
    <div class="meta">
      <span class="channel">{{ video().channel }}</span>
      <span class="dot">•</span>
      <span class="views">{{
        video().views && formatViews(video().views)
      }}</span>
      <span class="dot">•</span>
      <span class="uploaded">
        {{ video().uploadedAt && formatUploadedDate(video().uploadedAt) }}
      </span>
    </div>
  </div>
</div>
